const getNavigation = (t, customFilters = []) => {
  const filtersChildren = customFilters.map((filter, i) => ({
    kind: "item",
    segment: "reports/all/",
    query: filter.url_origin,
    title: filter?.name || `Filtro ${i + 1}`,
  }));

  const reportsGroup = {
    kind: "group",
    segment: "reports",
    title: t("Sidebar.reports"),
    iconName: "bold_document_text",
    children: [
      {
        kind: "item",
        segment: "reports/new",
        title: t("Sidebar.new_report"),
      },
      {
        kind: "item",
        segment: "reports/all/",
        title: t("Sidebar.all"),
      },
      {
        kind: "group", // Subgroup nested
        segment: "status",
        title: t("Sidebar.by_status"),
        children: [
          {
            kind: "item",
            segment: "reports/all/",
            query: "status=new",
            title: t("Sidebar.news"),
          },
          {
            kind: "item",
            segment: "reports/all/",
            query: "status=pending",
            title: t("Sidebar.pending"),
          },
          {
            kind: "item",
            segment: "reports/all/",
            query: "status=process",
            title: t("Sidebar.process"),
          },
          {
            kind: "item",
            segment: "reports/all/",
            query: "status=finish",
            title: t("Sidebar.finish"),
          },
          {
            kind: "item",
            segment: "reports/all/",
            query: "status=closed",
            title: t("Sidebar.closed"),
          },
        ],
      },
      {
        kind: "group", // Subgroup nested
        segment: "closed",
        title: t("Sidebar.closed"),
        children: [
          {
            kind: "item",
            segment: "reports/all/",
            query: "close_type=in_process",
            title: t("Sidebar.close_in_progress"),
          },
          {
            kind: "item",
            segment: "reports/all/",
            query: "close_type=founded",
            title: t("Sidebar.closed_founded"),
          },
          {
            kind: "item",
            segment: "reports/all/",
            query: "close_type=unfounded",
            title: t("Sidebar.closed_unfounded"),
          },
          {
            kind: "item",
            segment: "reports/all/",
            query: "close_type=undetermined",
            title: t("Sidebar.closed_undetermined"),
          },
        ],
      },
      ...(filtersChildren.length > 0
        ? [
            {
              kind: "group",
              segment: "filters",
              title: "Filtros personalizados",
              children: filtersChildren,
            },
          ]
        : []),
    ],
  };

  return [
    {
      kind: "item",
      segment: "dashboard",
      title: "Dashboard",
      iconName: "bold_element_2",
    },
    reportsGroup,
    {
      kind: "group",
      segment: "users",
      title: t("Sidebar.users"),
      iconName: "bold_profile_2_ser",
      activeMatch: ["users", "segments"],
      children: [
        { kind: "item", segment: "users", title: t("Sidebar.all_users") },
        { kind: "item", segment: "users/new", title: t("Sidebar.add_user") },
        { kind: "item", segment: "users/roles", title: "Roles" },
        {
          kind: "item",
          segment: "users/segments",
          title: t("Sidebar.groups"),
          activeMatch: ["segments"],
        },
      ],
    },
    {
      kind: "group",
      segment: "exports",
      title: t("Sidebar.exportables"),
      iconName: "bold_chart_square",
      activeMatch: ["exports", "analytics"],
      children: [
        {
          kind: "item",
          segment: "analytics/custom-dashboards",
          title: "BI Panel",
          activeMatch: ["analytics/custom-dashboards"],
        },
        {
          kind: "item",
          segment: "exports/builder",
          title: t("Sidebar.builder"),
        },
        {
          kind: "item",
          segment: "exports",
          title: t("Sidebar.generate"),
        },
        {
          kind: "item",
          segment: "analytics/dashboards",
          title: t("Sidebar.dynamic_dashboards"),
        },
      ],
    },
    {
      kind: "item",
      segment: "logs",
      title: t("Sidebar.logs"),
      iconName: "bold_document_filter",
    },
    {
      kind: "external",
      title: t("Sidebar.help"),
      href: "https://webservice.atlassian.net/servicedesk/customer/portal/",
      iconName: "bold_message_question_2",
    },
  ];
};

export default getNavigation;
